/** API-Texte nur als handlungsrelevante Hinweise anzeigen, ohne interne Werte. */
export function safeOperatorText(value: string): string {
  return value
    .replace(/https?:\/\/[^\s<>"']+/gi, '[interne Adresse]')
    .replace(/\bA[A-Z0-9]{12,}\b/g, '[interne Kennung]')
    .replace(/\b(token|secret|password|api[_-]?key)\s*[:=]\s*[^\s,;]+/gi, '$1: [geschützt]')
}

/**
 * Hinweis an den Namensfeldern. Reiner Erklärtext, KEINE zweite Prüfung: die
 * Namensregel gilt serverseitig (`validateCampaignName`), hier steht nur, wonach
 * sie fragt. Ohne diesen Hinweis ist die Regel im Editor nicht auffindbar.
 */
export const NAMENSREGEL_HINWEIS =
  'Format: PPC-Code am Anfang (z. B. 01_HGR_…), mindestens 8 Zeichen, keine doppelten Unterstriche, keine Steuerzeichen.'

/** Feldpfad des Servers (`groups[0].campaignName`) als Bezeichnung für den Operator. */
const FELDNAMEN: Record<string, string> = {
  clientRef: 'Gruppenkennung',
  class: 'Klasse',
  members: 'Mitglieder',
  campaignName: 'Kampagnenname',
  adGroupName: 'Anzeigengruppenname',
  dailyBudgetEur: 'Tagesbudget',
  queries: 'A/B-Queries',
}

export function feldBezeichnung(field: string | undefined): string | null {
  const treffer = /^groups\[(\d+)\]\.([A-Za-z]+)/.exec(field ?? '')
  const name = treffer ? FELDNAMEN[treffer[2]!] : undefined
  return treffer && name ? `Gruppe ${Number(treffer[1]) + 1} · ${name}` : null
}

/**
 * Fehlertext der Vorschau. Ein 400 nennt jetzt Feld und Grund aus der Antwort,
 * statt den Operator mit „Bitte erneut versuchen" in die Sackgasse zu schicken:
 * eine verletzte Namensregel wiederholt sich beliebig oft identisch.
 */
export function vorschauFehlertext(status: number | null, serverText: string | undefined, field: string | undefined): string {
  if (status === 409) return '409: Scope oder Dossier hat sich geändert. Bitte Daten aktualisieren und Angaben erneut prüfen.'
  if (status !== 400) return 'Vorschau konnte nicht geladen werden. Bitte erneut versuchen.'
  const bezeichnung = feldBezeichnung(field)
  const grund = serverText ? safeOperatorText(serverText) : 'Eingabe abgelehnt'
  const namensfeld = /(campaignName|adGroupName)/.test(field ?? '')
  return `Eingabe abgelehnt${bezeichnung ? ` — ${bezeichnung}` : ''}: ${grund}${namensfeld ? ` ${NAMENSREGEL_HINWEIS}` : ''}`
}

export function safeConfigReason(value: string): string {
  const name = value.match(/\bSTAHLIA_PRICING_(?:TOKEN|BASE_URL|PROFILE_MAP|TIMEOUT_MS)\b/i)?.[0]
  if (!name) return 'Konfiguration prüfen'
  return `${name}: ${/\bmissing\b/i.test(value) ? 'missing' : 'prüfen'}`
}
